import { useMultipleTokensMetadata } from '~/hooks/useTokenMetadata'
import { Automation } from '~/types/automations'

export const AutomationAccountOutput = ({
  automation,
}: {
  automation: Automation
}) => {
  const outputTokenMetadata = useMultipleTokensMetadata(
    automation.policy.outputs.map((output) => ({
      chainId: output.targetChainId,
      address: output.targetTokenAddress,
    })),
  )

  const outputParts = automation.policy.outputs.map((output, index) => {
    const symbol = outputTokenMetadata[index]?.symbol ?? 'UNKNOWN'
    return `${output.percent}% ${symbol}`
  })

  if (automation.policy.passThroughPercent > 0) {
    outputParts.push(`${automation.policy.passThroughPercent}% as-is`)
  }

  return <span className="truncate">{outputParts.join(', ')}</span>
}
